/**
 * @generated SignedSource<<6cc274e8ed17cd7c729be11344807368>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type usePersistedWalletAddress_viewer$data = {
  readonly user?: {
    readonly ethereumWalletAddress: {
      readonly address: string | null;
    } | null;
    readonly serviceId: string | null;
  } | null;
  readonly " $fragmentType": "usePersistedWalletAddress_viewer";
};
export type usePersistedWalletAddress_viewer$key = {
  readonly " $data"?: usePersistedWalletAddress_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"usePersistedWalletAddress_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "fetchUser"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./usePersistedWalletAddressQuery.graphql')
    }
  },
  "name": "usePersistedWalletAddress_viewer",
  "selections": [
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "ethereumWalletAddress",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "address",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "c670755b3f12a19c795e21dd218dc7c7";

export default node;
